import React from "react";
import { Helmet } from "react-helmet";
import {
  Headline,
  Paragraph,
  Section,
  ContentBlock,
  InlineLink,
} from "../components/ui";

const AGB = () => {
  return (
    <>
      <Helmet>
        <title>AGB | WTM Sportwagen</title>
        <meta
          name="description"
          content="Allgemeine Geschäftsbedingungen der WTM Sportwagen Werkstatt in Gießen."
        />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <Section variant="primary" spacing="spacious" margin={false}>
        <ContentBlock maxWidth="4xl" className="mx-auto">
          <Headline variant="h1" color="secondary" className="text-left mb-6">
            Allgemeine Geschäftsbedingungen (AGB)
          </Headline>

          <Paragraph
            variant="medium"
            color="secondary"
            className="text-left mb-4"
          >
            <strong>WTM Sportwagen Werkstatt</strong>
          </Paragraph>
          <Paragraph
            variant="medium"
            color="secondary"
            className="text-left mb-12"
          >
            Inhaber: Andreas Wutschke
            <br />
            Stand: 31.07.2025
          </Paragraph>

          {/* 1. Geltungsbereich */}
          <div className="mb-12">
            <Headline variant="h3" color="secondary" className="text-left mb-6">
              1. Geltungsbereich
            </Headline>
            <Paragraph variant="medium" color="secondary">
              Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für sämtliche
              Verträge, Leistungen und Angebote der WTM Sportwagen Werkstatt,
              Inhaber Andreas Wutschke, Grünbergerstraße 140, 35394 Gießen
              (nachfolgend „WTM" genannt). Sie gelten gegenüber natürlichen und
              juristischen Personen, soweit nicht ausdrücklich abweichende
              Regelungen schriftlich vereinbart wurden. Mit Auftragserteilung
              gelten diese Bedingungen als angenommen.
            </Paragraph>
          </div>

          {/* 2. Leistungsbeschreibung */}
          <div className="mb-12">
            <Headline variant="h3" color="secondary" className="text-left mb-6">
              2. Leistungsbeschreibung
            </Headline>
            <Paragraph variant="medium" color="secondary" className="mb-4">
              WTM erbringt handwerkliche und technische Leistungen im Bereich
              klassischer und moderner Porsche-Fahrzeuge. Dazu gehören
              insbesondere:
            </Paragraph>
            <ul className="list-disc list-inside space-y-2 mb-4 text-[var(--color-secondary)] opacity-90">
              <li>Motorinstandsetzung und Motorrevision</li>
              <li>
                Leistungssteigerungen durch mechanische und elektronische
                Maßnahmen
              </li>
              <li>
                Hubraumerweiterungen, Zylinderkopf- und Nockenwellenbearbeitung
              </li>
              <li>
                Fahrzeugrestauration, Individualumbauten, Karosseriearbeiten
              </li>
              <li>
                Herstellung und Einbau von Sonderteilen (z. B. CNC-Komponenten)
              </li>
              <li>Wartung, Diagnose und TÜV-nahe Vorbereitung</li>
            </ul>
            <Paragraph variant="medium" color="secondary">
              Die genaue Leistung ergibt sich aus dem schriftlichen Angebot oder
              der Auftragsbestätigung. Nachträgliche Änderungen bedürfen der
              Schriftform.
            </Paragraph>
          </div>

          {/* 3. Angebote und Vertragsschluss */}
          <div className="mb-12">
            <Headline variant="h3" color="secondary" className="text-left mb-6">
              3. Angebote und Vertragsschluss
            </Headline>
            <Paragraph variant="medium" color="secondary">
              Unsere Angebote sind freibleibend. Ein Vertrag kommt erst durch
              schriftliche Bestätigung oder tatsächlichen Beginn der Arbeiten
              durch WTM zustande. Zeichnungen, Abbildungen, Maße oder
              Leistungsangaben sind unverbindlich, sofern sie nicht ausdrücklich
              als verbindlich vereinbart wurden.
            </Paragraph>
          </div>

          {/* 4. Preise und Zahlungsbedingungen */}
          <div className="mb-12">
            <Headline variant="h3" color="secondary" className="text-left mb-6">
              4. Preise und Zahlungsbedingungen
            </Headline>
            <Paragraph variant="medium" color="secondary" className="mb-4">
              Alle Preise sind Nettoangaben zzgl. der jeweils gültigen
              gesetzlichen Mehrwertsteuer, sofern nicht ausdrücklich anders
              angegeben. Materialkosten, Fremdleistungen, TÜV-Gebühren oder
              Entsorgungskosten sind im Preis nicht enthalten, sofern nicht
              anders ausgewiesen.
            </Paragraph>
            <Paragraph variant="medium" color="secondary">
              Rechnungen sind sofort nach Zugang ohne Abzug fällig. Bei
              Zahlungsverzug ist WTM berechtigt, Verzugszinsen in gesetzlicher
              Höhe sowie Mahnkosten zu berechnen. Teilzahlungen oder
              Abschlagszahlungen können bei Projektbeginn verlangt werden.
            </Paragraph>
          </div>

          {/* 5. Eigentumsvorbehalt */}
          <div className="mb-12">
            <Headline variant="h3" color="secondary" className="text-left mb-6">
              5. Eigentumsvorbehalt
            </Headline>
            <Paragraph variant="medium" color="secondary">
              Bis zur vollständigen Bezahlung sämtlicher Forderungen behält sich
              WTM das Eigentum an allen gelieferten und eingebauten Teilen sowie
              Fahrzeugkomponenten vor. Der Kunde ist nicht berechtigt, diese
              weiterzugeben oder zu veräußern.
            </Paragraph>
          </div>

          {/* 6. Abnahme und Abholung */}
          <div className="mb-12">
            <Headline variant="h3" color="secondary" className="text-left mb-6">
              6. Abnahme und Abholung
            </Headline>
            <Paragraph variant="medium" color="secondary">
              Nach Fertigstellung wird der Kunde informiert. Das Fahrzeug ist
              binnen 5 Werktagen abzuholen. Mit der Übergabe oder dem
              Abtransport gilt die Leistung als abgenommen. Bei verspäteter
              Abholung kann WTM Standgebühren verlangen.
            </Paragraph>
          </div>

          {/* 7. Ausschluss von Gewährleistung und Garantie */}
          <div className="mb-12">
            <Headline variant="h3" color="secondary" className="text-left mb-6">
              7. Ausschluss von Gewährleistung und Garantie
            </Headline>
            <Paragraph variant="medium" color="secondary" className="mb-4">
              Bei sämtlichen Arbeiten an Motoren, Getrieben und weiteren
              technischen Komponenten – insbesondere bei Motorrevisionen,
              Leistungssteigerungen, Individualumbauten und Sonderanfertigungen
              – wird jegliche Gewährleistung und Garantie ausgeschlossen.
            </Paragraph>
            <Paragraph variant="medium" color="secondary" className="mb-4">
              <strong>
                Die Arbeiten erfolgen auf Risiko und in Verantwortung des
                Kunden.
              </strong>
            </Paragraph>
            <Paragraph variant="medium" color="secondary" className="mb-4">
              Insbesondere wird keine Haftung übernommen für:
            </Paragraph>
            <ul className="list-disc list-inside space-y-2 mb-4 text-[var(--color-secondary)] opacity-90">
              <li>
                Haltbarkeit, Laufleistung oder Funktion unter Dauer- oder
                Volllast
              </li>
              <li>
                Schäden durch sportlichen Einsatz, Überhitzung, falsche
                Handhabung
              </li>
              <li>Wechselwirkungen mit anderen Komponenten oder Software</li>
              <li>
                etwaige Schäden nach Übergabe (z. B. auf Prüfständen, bei
                Transport, durch Dritte)
              </li>
            </ul>
            <Paragraph variant="medium" color="secondary" className="mb-4">
              Es erfolgt keine Funktions- oder Haltbarkeitsgarantie. Der Kunde
              ist verpflichtet, das Fahrzeug nach Übergabe mit technischer
              Sorgfalt zu beobachten und Auffälligkeiten unverzüglich zu melden.
              Ein Unterlassen kann zu Haftungsausschluss führen.
            </Paragraph>
            <Paragraph variant="medium" color="secondary">
              Dieser Gewährleistungsausschluss gilt nicht bei grob fahrlässigem
              oder vorsätzlichem Verhalten von WTM.
            </Paragraph>
          </div>

          {/* 8. Stornierung durch den Kunden */}
          <div className="mb-12">
            <Headline variant="h3" color="secondary" className="text-left mb-6">
              8. Stornierung durch den Kunden
            </Headline>
            <Paragraph variant="medium" color="secondary">
              Wird ein erteilter Auftrag vor Beginn der Arbeiten storniert, kann
              WTM eine pauschale Bearbeitungsgebühr sowie bereits entstandene
              Material- oder Vorbereitungskosten verlangen. Bei Stornierung nach
              Beginn der Arbeiten ist WTM berechtigt, die bis dahin erbrachte
              Leistung vollständig in Rechnung zu stellen.
            </Paragraph>
          </div>

          {/* 9. Datenschutz */}
          <div className="mb-12">
            <Headline variant="h3" color="secondary" className="text-left mb-6">
              9. Datenschutz
            </Headline>
            <Paragraph variant="medium" color="secondary">
              WTM verarbeitet personenbezogene Daten ausschließlich im Rahmen
              der geltenden Datenschutzgesetze, insbesondere der DSGVO. Es
              gelten die unter{" "}
              <InlineLink to="/datenschutz">www.wtm-sportwagen.com</InlineLink>{" "}
              veröffentlichten Datenschutzbestimmungen.
            </Paragraph>
          </div>

          {/* 10. Gerichtsstand und Schlussbestimmungen */}
          <div className="mb-12">
            <Headline variant="h3" color="secondary" className="text-left mb-6">
              10. Gerichtsstand und Schlussbestimmungen
            </Headline>
            <Paragraph variant="medium" color="secondary">
              Es gilt deutsches Recht. Gerichtsstand ist Gießen, sofern
              gesetzlich zulässig. Nebenabreden und Vertragsänderungen bedürfen
              der Schriftform. Sollten einzelne Bestimmungen dieser AGB ganz
              oder teilweise unwirksam sein, bleibt die Gültigkeit der übrigen
              Regelungen unberührt.
            </Paragraph>
          </div>
        </ContentBlock>
      </Section>
    </>
  );
};

export default AGB;
